import api from "./api.js";


export const getTodayBookingAPI = async (SPORT_TYPE) => {
  try {
    const { data } = await api.get(
      "/booking/today",
      { params: { sportType: SPORT_TYPE } }
    );
    return data;
  } catch (err) {
    throw new Error("Failed to load bookings.");
  }
};
export const getBookingDetailsAPI = async ({ slot, sportType }) => {
  // بنبعت الداتا كـ query params
  const response = await api.get(`/booking/details`, {
    params: { slot, sportType },
  });
  return response.data;
};
export const getHistoryBookingsAPI = async ({ date, sportType }) => {
  const response = await api.get(`/booking/history`, {
    params: { date, sportType },
    // headers: { Authorization: ... } // لو مش بتستخدم interceptor
  });
  return response.data;
};

export const createBookingAPI = async ({ sportType, slot, teamName, members }) => {
  try {
    const { data } = await api.post(
      "/booking/create-booking",
      { sportType, slot, teamName, members }
    );
    return data;
  } catch (err) {
    throw new Error(err.response?.data?.message || "Booking failed.");
  }
};